module.exports = __webpack_public_path__ + "img/calendar.91a510f2.svg";